// extracted by mini-css-extract-plugin
module.exports = {"expandable":"Expandable_expandable__Lx72a","expandableWrapper":"Expandable_expandableWrapper__W85Sh"};